import React from 'react';

import classNames from 'classnames';

import {useFeature} from 'components/feature';
import {ShippingMethodType} from 'types/shippingMethodsType';

import {ShippingTwoDaysMethodRedesign} from '../shippingTwoDaysMethodRedesign/shippingTwoDaysMethodRedesign';

import s from './shippingTwoDaysWrapper.scss';

export type PropsType = {
    item: ShippingMethodType;
    itemRef: {ref: (node?: Element | null | undefined) => void} | {ref?: undefined};
    isActive: boolean;
    deliveryPrice: React.JSX.Element | 'Free';
    selectMethod: () => void;
};

/**
 * Shipping Two Days Wrapper for shipping methods list
 */
export const ShippingTwoDaysWrapper: React.FC<PropsType> = ({
    deliveryPrice,
    isActive,
    item,
    itemRef,
    selectMethod,
}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <React.Fragment key={item.code}>
            <div {...itemRef}>
                <ShippingTwoDaysMethodRedesign
                    code={item.code}
                    deliveryPrice={deliveryPrice}
                    isActive={isActive}
                    method={item}
                    selectShippingMethod={selectMethod}
                />
            </div>
            <div className={classNames(s.title, {[s.titleFacelift]: isFacelift})}>
                Or select one of these shipping options
            </div>
        </React.Fragment>
    );
};
